<template>
<div class="chapter">
<div class="inner_page">
<p class="cn" id="ch2">DARK-ENIGMA BIRD</p>
<p class="v">Heaven bade Dark-Enigma bird</p>
<p class="v">descend and give birth to Shang,</p>
<p class="v">our people inhabiting lands boundless and beyond,</p>
<p class="v">then our Celestial Lord bade brave and forceful T’ang</p>
<p class="v">establish boundaries to the far corners of our lands,</p>
<p class="v">bade him then rule these lands,</p>
<p class="v">these nine regions in splendor.</p>
<p class="v">So T’ang, first emperor of Shang,</p>
<p class="v">received the Mandate. Ever safe,</p>
<p class="v">it has passed now to Wu Ting’s</p>
<p class="v">sons, to his sons and grandsons,</p>
<p class="v">our emperors brave and forceful,</p>
<p class="v">nothing they will not overcome—</p>
<p class="v">their lords with dragon banners</p>
<p class="v">parading grains to the sacrifice,</p>
<p class="v">their domain thousands of miles</p>
<p class="v">offering the people sure support.</p>
<p class="v">He pushed the boundaries of our land to the four seas,</p>
<p class="v">and now from the four seas comes</p>
<p class="v">homage, such abounding homage.</p>
<p class="v">And our far frontier is the river.</p>
<p class="v">That Shang received the Mandate was due, right and due,</p>
<p class="v">and its hundred blessings continue.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?a6507e90